import React from 'react';
import { CardMedia } from '@mui/material';
import img from '../assets/EduzyLogo.png';

const Logo: React.FC = () => {
  return (
    <CardMedia
      component="img"
      sx={{
        height: 20,
        mr: 0.5,
        width: 'auto',
        display: 'inline-block',
        left: 'inherit',
      }}
      src={img}
    />
  );
};

export default Logo;
